export function initQuantityStepper() {
  document.querySelectorAll('.qty-stepper').forEach((stepper) => {
    const input = stepper.querySelector('.qty-input');
    const minus = stepper.querySelector('.qty-btn--minus');
    const plus = stepper.querySelector('.qty-btn--plus');
    const min = parseInt(input.min, 10) || 1;
    const max = parseInt(input.max, 10) || 99;

    const clearError = () => {
      stepper.classList.remove('has-error');
      const errorEl = document.getElementById('qtyError');
      if (errorEl) errorEl.hidden = true;
    };

    minus.addEventListener('click', () => {
      const val = Math.max(min, (parseInt(input.value, 10) || min) - 1);
      input.value = val;
      clearError();
    });

    plus.addEventListener('click', () => {
      const val = Math.min(max, (parseInt(input.value, 10) || min) + 1);
      input.value = val;
      clearError();
    });

    input.addEventListener('change', () => {
      let val = parseInt(input.value, 10) || min;
      val = Math.min(max, Math.max(min, val));
      input.value = val;
      clearError();
    });
  });
}

export function initDealModal() {
  const overlay = document.getElementById('dealModalOverlay');
  const closeBtn = document.getElementById('dealModalClose');
  const buyBtn = document.querySelector('.btn-buy');
  const form = document.getElementById('dealModalForm');
  const dealSection = document.querySelector('.deal-detail');

  if (!overlay || !buyBtn || !dealSection) return;

  const pageQtyInput = dealSection.querySelector('.qty-input');
  const qtyStepper = dealSection.querySelector('.qty-stepper');
  const qtyError = document.getElementById('qtyError');

  const productIdInput = document.getElementById('productId');
  const productNameInput = document.getElementById('productName');
  const productQtyInput = document.getElementById('productQuantity');

  const validateQuantity = () => {
    const qty = parseInt(pageQtyInput.value, 10);
    const min = parseInt(pageQtyInput.min, 10) || 1;

    if (isNaN(qty) || qty < min) {
      qtyStepper.classList.add('has-error');
      if (qtyError) qtyError.hidden = false;
      pageQtyInput.focus();
      return false;
    }

    qtyStepper.classList.remove('has-error');
    if (qtyError) qtyError.hidden = true;
    return true;
  };

  const openModal = () => {
    if (!validateQuantity()) return;

    // Prefill from the deal detail section — single source of truth
    const dealId = dealSection.dataset.dealId || buyBtn.dataset.dealId || '';
    const dealName = dealSection.dataset.dealName || buyBtn.dataset.dealName || '';
    const qty = pageQtyInput.value;

    productIdInput.value = dealId;
    productNameInput.value = dealName;
    productQtyInput.value = qty;

    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { overlay.hidden = true; }, 250);
  };

  buyBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(form).entries());
    console.log('Order submitted:', data);
    // data.product_id, data.product_name, data.product_quantity
    // plus buyer name, phone, email, address
    // TODO: replace with actual submit handler / API call
    closeModal();
    form.reset();
  });
}